import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="team-bulk-form"
export default class extends Controller {
  static targets = ["tbody", "template"];
  connect() {
    this.templateRow = `
      <tr>
        <td>
        <input type="text" class="form-control w-100" placeholder="例：A班 / GRP01">
        </td>
        <td>
        <input type="text" class="form-control w-100" placeholder="例：第1作業班">
        </td>
        <td>
          <button class="btn btn-sm btn-outline-danger" data-action="team-bulk-form#removeRow">削除</button>
        </td>
      </tr>
    `.trim();
  }

  addRow(event) {
    event.preventDefault()
    const newRow = document.createElement("tr")
    newRow.innerHTML = this.templateRow
    newRow.querySelectorAll("input, select, textarea").forEach((input) => {
      input.value = ""
    })
    this.tbodyTarget.appendChild(newRow)
  }

  removeRow(event) {
    event.preventDefault()
    const row = event.target.closest("tr")
    if (row) {
      row.remove()
    }
  }

  clear(event) {
    event.preventDefault()
    this.tbodyTarget.querySelectorAll("input").forEach(input => input.value = "")
  }

  addSampleRows(event) {
    event.preventDefault()
    const samples = [
      { code: "A001", name: "第1作業班" },
      { code: "B002", name: "第2作業班" },
      { code: "C003", name: "第3作業班" }
    ]

    // Clear existing rows
    this.tbodyTarget.innerHTML = ""

    samples.forEach(sample => {
      const newRow = document.createElement("tr")
      newRow.innerHTML = this.templateRow
      const inputs = newRow.querySelectorAll("input")
      inputs[0].value = sample.code
      inputs[1].value = sample.name
      this.tbodyTarget.appendChild(newRow)
    })
  }

}
